<template>
  <div class="flex flex-col gap-2">
    <el-form :disabled="disabled" label-width="0">
      <template v-if="Object.keys(paramValue).length > 0">
        <el-form-item label="" v-for="(value, key) in paramValue" :key="key">
          <div class="flex flex-row items-center gap-4 border-b py-2">
            <div class="w-32 text-sm font-medium">{{ key }}:</div>
            <div class="flex-1">
              <el-switch v-if="isBoolean(value)" v-model="paramValue[key]" />
              <el-input
                v-else-if="isNumber(value)"
                v-model.number="paramValue[key]"
                type="number"
                :step="0.01"
                style="width: 120px"
              />
              <el-input
                v-else
                v-model="paramValue[key]"
                placeholder="Enter value"
                style="width: 180px"
              />
            </div>
            <div v-if="!disabled" class="flex items-center justify-center">
              <el-button icon="el-icon-delete" @click="removeKey(key)" />
            </div>
          </div>
        </el-form-item>
      </template>
      <template v-else class="flex flex-row">
        <div class="text-yellow-400">
          Please add key-value pairs click the button below
          <span style="font-size: 1.2em">👇</span>.
        </div>
      </template>
      <div v-if="!disabled" class="flex flex-row gap-4 mt-2">
        <el-input v-model="newKey" placeholder="Key" style="width: 120px" />
        <el-input v-model="newValue" placeholder="Value" style="width: 120px" />
        <el-button type="primary" @click="addKey">Add</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ObjectParamEditor",
  emits: ["input"],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      newKey: "",
      newValue: "",
    };
  },
  computed: {
    paramValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    isBoolean(val) {
      return typeof val === "boolean";
    },
    isNumber(val) {
      return typeof val === "number";
    },
    addKey() {
      if (this.newKey) {
        let v = this.newValue;
        if (v === "true" || v === "false") v = v === "true";
        else if (!isNaN(Number(v))) v = Number(v);
        this.$set(this.paramValue, this.newKey, v);
        this.newKey = "";
        this.newValue = "";
        this.$emit("input", this.paramValue);
      }
    },
    removeKey(key) {
      this.$delete(this.paramValue, key);
      this.$emit("input", this.paramValue);
    },
  },
};
</script>
